var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5733 3.84473C11.2804 3.55184 10.8055 3.55184 10.5126 3.84473C10.2197 4.13762 10.2197 4.6125 10.5126 4.90539L15.0643 9.45709H3.95703C3.54282 9.45709 3.20703 9.79288 3.20703 10.2071C3.20703 10.6213 3.54282 10.9571 3.95703 10.9571H15.0652L10.5125 15.5129C10.2197 15.8059 10.2198 16.2808 10.5128 16.5735C10.8058 16.8663 11.2807 16.8662 11.5735 16.5732L17.4055 10.7372C17.4082 10.7345 17.4109 10.7318 17.4136 10.7291C17.6299 10.506 17.6802 10.1817 17.5645 9.91156C17.5318 9.83504 17.4857 9.76287 17.4263 9.69857C17.4837 9.76075 17.5307 9.83267 17.5645 9.91156",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5733 3.84473L17.4029 9.67438L11.5733 3.84473Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6a15c7155685f03378e60dcbed678d76.svg";
export { ForwardRef as ReactComponent };